import * as React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import './ViewerManual.scss';
import { connect } from 'react-redux';
import { IStateApp } from '../Reducers/index';
import { IAccount } from '../Models/Account';
import { Icon } from '@material-ui/core';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface IViewerManualProps extends IAccount {

}

export const ViewerManual = (props: IViewerManualProps) => {
	const [numPages, setNumPages] = React.useState<number[]>([]);
	const onDocumentoLoadSuccess = (load: any) => {
		const pages = [];
		for (let i = 1; i <= load.numPages; i ++) {
			pages.push(i);
		}
		setNumPages(pages);
	}
	const getUrl = () => {
		const path =  process.env.NODE_ENV.trim() === 'development' ? '/' : '';
		if (props.idProfile === 1) {
			return path + 'Manual _Puerto Angamos _Copper Tracker_Full.pdf';
		}
		return path + 'Manual _Puerto Angamos _Copper Tracker_Cliente.pdf';
	}

	return <div className="container-manual">
		<a download className="download-manual" href={getUrl()}>
			<Icon>cloud_download</Icon>
			<p>Descargar</p>
		</a>
		<Document
			className="viewer-manual"
			file={getUrl()}
			onLoadSuccess={onDocumentoLoadSuccess}
		>
			{numPages.map(p => <Page pageNumber={p} />)}
		</Document>
	</div>
}

export default connect((state: IStateApp) => state.session.account)(ViewerManual);
